import { render, staticRenderFns } from "./icon-back.vue?vue&type=template&id=5ce5eea4"
import script from "./icon-back.vue?vue&type=script&lang=ts"
export * from "./icon-back.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports